<template>
  <div id="app" class="app" :class="{'app--has-header': hasHeader, 'app--has-footer': hasFooter, 'app--is-embedded': isEmbedded }">
    <router-view name="header" v-show="hasHeader"></router-view>
    <router-view></router-view>
    <router-view name="footer" v-show="hasFooter"></router-view>
  </div>
</template>

<script>
import get from 'lodash/get'
import { EmbedableFooter } from '@icij/murmur'

export default {
  name: 'App',
  mounted() {
  },
  computed: {
    routeComponents () {
      return get(this, '$route.matched[0].components', {})
    },
    socialMode () {
      return !!this.$route.query['social-mode']
    },
    noEmbeddableFooter () {
      return !!this.$route.query['no-embeddable-footer']
    },
    hasFooter () {
      return !!this.routeComponents.footer && !this.socialMode && !this.noEmbeddableFooter
    },
    hasHeader () {
      return !!this.routeComponents.header && !this.socialMode
    },
    isEmbedded () {
      return this.routeComponents.footer === EmbedableFooter
    }
  }
}
</script>

<style lang="scss">
  .app {

    &--social-mode {
      padding-bottom: 1rem;
    }

    &--has-header {
      margin-top: 1.5rem + 2 * $spacer;
      @include media-breakpoint-up(lg) {
        margin-top: 1.8rem + 2 * $spacer;
      }
    }

    &--is-embedded {
      padding-bottom: 4rem;
    }

    &--is-embedded.app--has-footer {      
      min-height: 100vh;
      border: 1px solid black;
    }
  }
</style>
